<template >
    <div>
 <CCard class="b-none">
             <CCardBody  class="p-0 overflow-unset mt--15px">
                
                <!-- <div v-if="isPriceChanged"> 
                <GraphSlider  id="obpricefilter"
                    myId="priceobfilterid"
                    style="margin: 30px auto"
                    :width="250"
                    :bar-height="100"
                    :data="priceObFilterList"
                    :keyboard="false"                   
                    :force-edges="false"
                    :colors="['#4facfe', '#00f2fe']"
                    :min="Math.min.apply(Math,priceObFilterList)"
                    :max="Math.max.apply(Math,priceObFilterList)"
                    :from="parseInt(filterObWatList['price'].from)"
                    :to="parseInt(filterObWatList['price'].to)"
                    @change="onpriceChange"
                    @finish="onpriceChanged"
                   
                  />
                  </div> -->
                  <!-- {{filterObWatchList.totalDuration}} -->
                  <!-- {{'start '+filterObWatchList.totalDuration.start}}-{{'end '+filterObWatchList.totalDuration.end}}-{{'from '+filterObWatchList.totalDuration.from}}-{{'to '+filterObWatchList.totalDuration.to}} -->
                   <div id="main">
              <br>
              <div  id="obDurslider" ref="obDurslider">
              
              </div>
              <br> 
                       
            </div>
                    </CCardBody>
            </CCard>
            

          
    </div>
</template>
<script>
import Logger from "../../services/logger";
import BaseConfiguration from "../../config/base.js";
import { mapGetters, mapActions } from "vuex";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";

import { cloneData } from '../../util/util';
import { COMPONENT_NAME,FILTER } from "../../util/constants.js";
import noUiSlider from 'nouislider';
 
// import GraphSlider from 'vue-graph-slider';
// import 'vue-graph-slider/dist/graph-slider.css';
// import Vue from 'vue';
// Vue.component(GraphSlider.name, GraphSlider);

export default {
    name:COMPONENT_NAME.C_FILTER_DUR_OB,
     model: {  
    prop: "selValue"
  },
    props: {
   
     flightRes: {
      type: Array | Object
    },
     filterObWatList: {
      type: Object
    },
    selectedDur:{
      type:Object
    }
    },
    data() {
    return {  
      priceObFilterList: {
      type:  Array
    },
        filterObWatchList:{},
      
    obDurslider:null,
    sliderVal:{
        startVal:0,
        endVal:0,
        fromVal:0,
        toVal:0,
        
      },
      softLimitVal:0  
    }},
  
      watch: {
    // selValue(val) {
    //   if (val !== this.selValueModel) {
    //     this.selValueModel = val;
    //   }
    // },
    filterObWatList:{
      
      deep:true,
      handler: function (newVal, oldVal) {
         this.filterObWatchList=this.filterObWatList;
        this.obDurslider.noUiSlider.set([this.filterObWatchList[FILTER.C_FILTER_DUR].from, 
                        this.filterObWatchList[FILTER.C_FILTER_DUR].to]);
        
      }
    },

 
  },
 

    methods:{

     
    assignObSliderData() {
    
        try {
          if(BaseConfiguration.isDebug) console.log("assignObSliderData");
          // alert(this.filterObWatchList[FILTER.C_FILTER_DUR].end*FILTER.SOFTLIMIT_VAL/100);
          // this.sliderVal=this.toCheckSoftLimitVal();
          if(this.filterObWatchList[FILTER.C_FILTER_DUR].start==1) {
            
            this.sliderVal.startVal=1;
            this.sliderVal.endVal=this.filterObWatchList[FILTER.C_FILTER_DUR].end+this.softLimitVal;
            this.sliderVal.fromVal=2;
            this.sliderVal.toVal=this.filterObWatchList[FILTER.C_FILTER_DUR].end;
         
          }
          
          else{
            this.sliderVal.startVal=this.filterObWatchList[FILTER.C_FILTER_DUR].start-this.softLimitVal;
            this.sliderVal.endVal=this.filterObWatchList[FILTER.C_FILTER_DUR].end+this.softLimitVal;
            this.sliderVal.fromVal=this.filterObWatchList[FILTER.C_FILTER_DUR].start;
            this.sliderVal.toVal=this.filterObWatchList[FILTER.C_FILTER_DUR].end;
          }
         
      noUiSlider.create(this.obDurslider, {
      start: [this.sliderVal.fromVal, this.sliderVal.toVal],
      step: 1,
      connect: true,
     behaviour: 'drag',
      tooltips: true,
      format: {
            to: function (value) {
            
      return parseInt(value/60)+' hr '+parseInt(value%60)+' min';
    },
    from: function(value) {
      return value;
    }
          },
      range: {
        'min': this.sliderVal.startVal,
        'max':  this.sliderVal.endVal
      },
      // Show a scale with the slider
      pips: {
          mode: 'values',
          values: [this.sliderVal.fromVal,this.sliderVal.toVal],
          density: 4,
          format: {
            to: function (value) {
              if(value==0) {
                return 0;
              }else{
      return parseInt(value/60)+' hr '+parseInt(value%60)+' min';
              }
    },
    from: function(value) {
      return value;
    }
      }
      }
    }); 
   
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_FILTER_PRICE_OB,
                  "error in assignObSliderData",
                  err.toString(),
                  "assignObSliderData",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          // return sliderVal;
    }, 

    getMinutes(pValue) {
       let retValue;
       var arr=[];
        try {
          if(BaseConfiguration.isDebug) console.log("getMinutes");
         arr=pValue.split(" ");
         retValue = parseInt(arr[0]) * 60 + parseInt(arr[2]);
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.C_FILTER_DUR_OB,
                  "error in getMinutes",
                  err.toString(),
                  "getMinutes",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
   }, 
    
        
    },

    created(){

      this.filterObWatchList=this.filterObWatList; 
     ///softlimitValue in order to choose the minimum value/max value
      this.softLimitVal=Math.round(this.filterObWatchList[FILTER.C_FILTER_DUR].end*FILTER.SOFTLIMIT_VAL/100)+1;

    },
    mounted(){
      this.obDurslider = document.getElementById('obDurslider');
      this.assignObSliderData();
       this.obDurslider.noUiSlider.set([this.filterObWatchList[FILTER.C_FILTER_DUR].from, 
                        this.filterObWatchList[FILTER.C_FILTER_DUR].to]);
    
        let selectedDur;    
    this.obDurslider.noUiSlider.on('change',(values, handle) => {
      if(this.filterObWatchList[FILTER.C_FILTER_DUR].start==this.filterObWatchList[FILTER.C_FILTER_DUR].end) {
        selectedDur= {
            from:this.getMinutes(values[0]),
              to:this.getMinutes(values[1]),
              start:1,
              end:this.filterObWatchList[FILTER.C_FILTER_DUR].end+this.softLimitVal,
              
              by:'user'
            }
      } else{
        selectedDur= {
            from:this.getMinutes(values[0]),
              to:this.getMinutes(values[1]),
              start:this.filterObWatchList[FILTER.C_FILTER_DUR].start-this.softLimitVal,
              end:this.filterObWatchList[FILTER.C_FILTER_DUR].end+this.softLimitVal,
              by:'user'
            }
      }
      
            this.$emit('input',selectedDur,FILTER.C_FILTER_DUR);
            
      
    }); 

    // let selectedDur={
    //       start:0,
    //       end:0,
    //       from:0,
    //       to:0,
    //       by:null
    //     };
        
    //     this.sliderVal=this.toCheckSoftLimitVal();
    //   this.obDurslider.noUiSlider.on('change',(values, handle) => {
        
    //   if(this.filterObWatchList){
    //     if(values[0] >= this.sliderVal.startVal && values[1] <= this.sliderVal.endVal){
    //       selectedDur.start=this.sliderVal.startVal;
    //       selectedDur.from=values[0];
    //       selectedDur.end=this.sliderVal.endVal;
    //       selectedDur.to=values[1];
    //       selectedDur.by='user';
    //     this.obDurslider.noUiSlider.set([selectedDur.from,selectedDur.to]);
    //     }
    //     else if(!values[0] >= this.sliderVal.startVal && !values[1] <= this.sliderVal.endVal) {
         
    //       selectedDur.start=this.sliderVal.startVal;
    //       selectedDur.from=this.sliderVal.fromVal;
    //       selectedDur.end=this.sliderVal.endVal;
    //       selectedDur.to=this.sliderVal.toVal;
    //       selectedDur.by='user'
    //     this.obDurslider.noUiSlider.set([selectedDur.from,selectedDur.to]);
    //     }
    //   if (values[0] <= this.sliderVal.startVal && values[1] <= this.sliderVal.endVal) {
    //     selectedDur.start=this.sliderVal.startVal;
    //     selectedDur.from=this.sliderVal.fromVal;
    //     selectedDur.end=values[1];
    //     selectedDur.to=values[1];
    //     selectedDur.by='user';
    //     this.obDurslider.noUiSlider.set([selectedDur.from,selectedDur.to]);
    // } 
    // if (values[1] >= this.sliderVal.endVal && values[0] >= this.sliderVal.startVal) {
    //   selectedDur.start=values[0];
    //   selectedDur.from=values[0];
    //   selectedDur.end=this.sliderVal.endVal;
    //   selectedDur.to=this.sliderVal.toVal;
    //   selectedDur.by='user'
    //     this.obDurslider.noUiSlider.set([selectedDur.from,selectedDur.to]);
    // }
    //   }
    //         this.$emit('input',selectedDur,FILTER.C_FILTER_DUR);
            
      
    // }); 
            
    
    }
  
}
</script>
<style>
@import '../../assets/mf/css/nouislider.min.css';
.noUi-tooltip {
    display: none;
}
.noUi-active .noUi-tooltip {
    display: block;
}
</style>